function Home(){
    return(
        <>
            <h1>hey iam home</h1>
        </>
    )
}
export default Home